// extracted by mini-css-extract-plugin
export default {"table":"articleList_table__Q7yTF"};